import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Beneficiary extends Model {
    static entity = 'Household\\Model\\Beneficiary';

    static fields() {
        return {
            id: this.attr(null),
            first_name: this.attr(''),
            last_name: this.attr(''),
            minor: this.boolean(false),
            beneficiaryAssignmentsAsAssigned: this.morphMany(BeneficiaryAssignment, 'assigned_id', 'assigned_type'),
        }
    }

    get name() {
        return this.first_name + ' ' + this.last_name;
    }

    get displayName() {
        return this.first_name;
    }

    get type() {
        return 'Household\\Model\\Beneficiary';
    }

}
